import React, { FC } from "react";
import { IRoom, PageRoutes, setClass } from "../../../utils";
import { Link } from "react-router-dom";
import { Camera, Telephone, Display, Projector, TouchScreen } from "../../svgs";
import "../../../styles/components/filter.scss";
import {
  getTypeOfCountingPlural,
  seatsPlural,
} from "../../../utils/constants/pluralForm";

interface FilterRoomOptionProps {
  room: IRoom;
  selected: number;
  onChooseRoom: (roomNumber: number) => void;
}

export const FilterRoomOption: FC<FilterRoomOptionProps> = ({
  room,
  selected,
  onChooseRoom: chooseRoom,
}) => {
  const onChooseRoom = () => chooseRoom(room.cabinetNumber);
  const activeClass = selected === room.cabinetNumber && "active";
  const iconClassName = setClass("rooms-options", activeClass);
  return (
    <Link to={PageRoutes.CALENDAR_PAGE} className="reset-link">
      <div className="room" onClick={onChooseRoom} key={room.conferenceType}>
        <div className="room-name">
          <div className={setClass("cabinet-number", activeClass)}>
            {room.cabinetNumber}
          </div>
          <div className={setClass("name", activeClass)}>
            {room.conferenceTitle}
          </div>
        </div>
        <div className="options">
          <div className={setClass("seat-numbers", activeClass)}>
            {`${room.seatNumber} ${getTypeOfCountingPlural(
              room.seatNumber,
              seatsPlural
            )}`}
          </div>
          <div className="icons">
            {room.webCamera?.isExist && (
              <Camera
                divClassName={iconClassName}
                tooltip={room.webCamera?.description}
              />
            )}
            {room.phone?.isExist && (
              <Telephone
                divClassName={iconClassName}
                tooltip={room.phone?.description}
              />
            )}
            {room.laptop?.isExist && (
              <Display
                divClassName={iconClassName}
                tooltip={room.laptop?.description}
              />
            )}
            {room.projector?.isExist && (
              <Projector
                divClassName={iconClassName}
                tooltip={room.projector?.description}
              />
            )}
            {room.touchScreenPanel?.isExist && (
              <TouchScreen
                divClassName={iconClassName}
                tooltip={room.touchScreenPanel?.description}
              />
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
